import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import Address from "@/shared/model/Address";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import SogScheduleSerieLabel from "@/shared/ui/SogScheduleSerie/SogScheduleSerieLabel.vue";

interface Props {
  details?: PersonDetails
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExternalInterfaceCardComponent',
  props: {
    details: { default: undefined }
  },
  emits: [ 'updated'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const _emit = __emit

function onExportNow() {
  _emit('updated');
}

// async function onExportNow() {
//   if (!_details || !_person.value?.id) return;
//
//   _spinner.show();
//   try {
//     const success = await apiOrganisationStructure.updateDetails(
//         _accountStore.person?.id, _person.value?.id, _details.getValues()
//     );
//
//     if (success) {
//       await p_init(_route);
//     }
//   } finally {
//     _spinner.hide();
//   }
// }





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card" }, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Schnittstelle ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", null, "Schedule", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogScheduleSerieLabel, {
                  value: __props.details?.getValue(_unref(PersonDetailsId).ExternalInterfaceExportSchedule)
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("td", null, "Nächster Export", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.details?.getValue(_unref(PersonDetailsId).ExternalInterfaceExportNext),
                  "value-type": _unref(SogDataLabelValueType).DateTime
                }, null, 8, ["value", "value-type"])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActionButton, { onClick: onExportNow }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Jetzt exportieren ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})